import styled, { keyframes } from 'styled-components';
import { TransitionGroup } from 'react-transition-group';

const fadeOut = keyframes`
  from { transform: translateX(0); opacity: 1; }
  to { transform: translateX(1rem); opacity: 0; }
`;

const fadeIn = keyframes`
  from { transform: translateX(1rem); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

export const fadeOutOpacity = keyframes`
  from { opacity: 1; } to { opacity: 0; }
`;

export const fadeInOpacity = keyframes`
  from { opacity: 0; } to { opacity: 1; }
`;

export const TransformTransitionGroup = styled(TransitionGroup)<{ $transitionName: string }>`
  ${({ $transitionName }) => `.${$transitionName}-enter`} {
    opacity: 0;
  }

  ${({ $transitionName }) => `.${$transitionName}-enter-done`} {
    animation: ${fadeIn} 0.3s cubic-bezier(0.4, 0.1, 0.1, 0.9) forwards;
    will-change: transform;
  }

  ${({ $transitionName }) => `.${$transitionName}-exit`} {
    opacity: 1;
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }

  ${({ $transitionName }) => `.${$transitionName}-exit-active`} {
    animation: ${fadeOut} 0.3s cubic-bezier(0.4, 0.1, 0.1, 0.9) forwards;
    will-change: transform;
  }
`;
